import { autoRegisterFeature } from '@store/features/factory';

import { eligibilityChecksFeature } from './store/feature';

autoRegisterFeature(eligibilityChecksFeature);

export * from './components';
export * from './store';
export * from './types';

